<template>
    <ScrollPanel style="height: 450px;">
        <div style="padding-right: 25px;">
            <div v-for="e in flowEntries" :key="e">
                <div class="flowEntryContainer">
                    <div>{{ utils.formatDate(e.timestamp) }}</div>
                    <div class="flex flex-wrap align-items-center">
                        <img :src="e.user.imageUrl" class="user_avatar" tabindex="1"
                            v-tooltip.focus.left="e.user.fullName" />
                        <div style="margin-right: 0.5em;">
                            <span>
                                {{ $t(operationStatusNumericEnum[e.statusBeforeId]) }}
                            </span>
                            <font-awesome-icon :icon="['fas', 'arrow-left']" style="margin: 0 5px 0 5px;" />
                            <span>
                                {{ $t(operationStatusNumericEnum[e.statusAfterId]) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="shouldShowEmptyResults()">
                <font-awesome-icon :icon="['fas', 'ellipsis']" size="2xl" />

                {{ $t('EMPTY') }}

            </div>
        </div>
    </ScrollPanel>
</template>

<script setup>
import { ref, onBeforeMount, inject } from 'vue'
import operationService from '@/service/OperationService'
import userService from '@/service/UserService'
import { operationStatusNumericEnum } from '@/helpers/Constants'
import utils from '@/helpers/Utils'

const dialogRef = inject("dialogRef")

const emit = defineEmits(['flow-query-failed'])

const flowEntries = ref([])

onBeforeMount(async () => {
    try {
        const response = await operationService.getFlowEntries(dialogRef.value.data.operationId)
        if (response.result.collection.length > 0) {
            flowEntries.value = response.result.collection
            userService.decorate(response.result.collection.map(e => e.user))
        }
    } catch (e) {
        emit('flow-query-failed', e)
    }
})

const shouldShowEmptyResults = () => {
    return flowEntries.value === null || flowEntries.value === undefined || flowEntries.value.length === 0
}

</script>

<style scoped>
.flowEntryContainer {
    margin-bottom: 1.5em;
    direction: rtl;
}

.user_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
}
</style>